const LOGO_URL = 'https://static.readdy.ai/image/2eeb7004bec3dab6605078c5e30f883b/03d84a07dc69ca97a2487f53039402b6.jpeg';

export default function Header() {
  return (
    <header
      data-track-view="true"
      data-element-id="header"
      data-element-type="header"
      data-element-name="ヘッダー"
      data-element-index="0"
      style={{
        background: '#fff',
        boxShadow: '0 1px 0 rgba(0,0,0,0.07)',
        position: 'sticky',
        top: 0,
        zIndex: 100,
      }}
    >
      <div
        style={{
          maxWidth: 430,
          margin: '0 auto',
          padding: '10px 16px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        {/* Logo – links to corporate site */}
        <a
          href="https://nijikango.co.jp/"
          target="_blank"
          rel="noopener noreferrer"
          data-track-tap="true"
          data-element-id="logo_link"
          data-element-type="link"
          data-element-name="ロゴリンク"
          data-element-index="0"
          style={{ display: 'flex', alignItems: 'center', textDecoration: 'none' }}
        >
          <img
            src={LOGO_URL}
            alt="ニジ看護転職"
            style={{
              width: 160,
              height: 'auto',
              objectFit: 'contain',
            }}
          />
        </a>

        {/* License number */}
        <div
          style={{
            fontSize: 11,
            color: '#999',
            lineHeight: 1.5,
            textAlign: 'right',
            maxWidth: 140,
          }}
        >
          厚生労働大臣許可番号<br />
          <span style={{ fontWeight: 700, color: '#666', fontSize: 12 }}>13-ユ-317878</span>
        </div>
      </div>
    </header>
  );
}
